import angular from "angular";
import uiRouter from "angular-ui-router";

import postashiftwalkthroughComponent from "./postashiftwalkthrough.component";

import locationComponent from "./scenes/location/location.component";

import dateandtimeComponent from "./scenes/dateandtime/dateandtime.component";
import positiontypeComponent from "./scenes/positiontype/positiontype.component";
import openingsComponent from "./scenes/openings/openings.component";

import shifttitleComponent from "./scenes/shifttitle/shifttitle.component";
import shiftdescriptionComponent from "./scenes/shiftdescription/shiftdescription.component";
import suggestedattireComponent from "./scenes/suggestedattire/suggestedattire.component";
import arrivalinstructionsComponent from "./scenes/arrivalinstructions/arrivalinstructions.component";
import companyinfoComponent from "./scenes/companyinfo/companyinfo.component";

import questionsComponent from "./scenes/questions/questions.component";
import requirementsComponent from "./scenes/requirements/requirements.component";

import hiringmanagerComponent from "./scenes/hiringmanager/hiringmanager.component";

import payrateComponent from "./scenes/payrate/payrate.component";

import previewComponent from "./scenes/preview/preview.component";

let postashiftwalkthroughModule = angular
  .module("postashiftwalkthrough", [uiRouter, "cleave.js"])
  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";
    $stateProvider.state("postashiftwalkthrough", {
      url: "/post-a-shift/walkthrough?cid&eid",
      template: "<postashiftwalkthrough></postashiftwalkthrough>",
      title: "Post a Job",
      params: {
        job: null,
        cid: null,
        eid: null,
      },
    });
  })
  .component("postashiftwalkthrough", postashiftwalkthroughComponent)
  .component("location", locationComponent)
  .component("positiontype", positiontypeComponent)
  .component("openings", openingsComponent)
  .component("dateandtime", dateandtimeComponent)
  .component("shifttitle", shifttitleComponent)
  .component("shiftdescription", shiftdescriptionComponent)
  .component("suggestedattire", suggestedattireComponent)
  .component("arrivalinstructions", arrivalinstructionsComponent)
  .component("companyinfo", companyinfoComponent)
  .component("questions", questionsComponent)
  .component("requirements", requirementsComponent)
  .component("hiringmanager", hiringmanagerComponent)
  .component("payrate", payrateComponent)
  .component("preview", previewComponent);

export default postashiftwalkthroughModule;



// WEBPACK FOOTER //
// ./client/app/scenes/postashiftwalkthrough/postashiftwalkthrough.js